var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.contract },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { class: _vm.$hasErrorClass(_vm.$v.contract.name, "form-group") },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Name"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.contract.name.$model,
                      expression: "$v.contract.name.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "Contract name",
                  },
                  domProps: { value: _vm.$v.contract.name.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.contract.name,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.contract.name, label: "Name" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.contract.description,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Description"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.contract.description.$model,
                      expression: "$v.contract.description.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "Description",
                  },
                  domProps: { value: _vm.$v.contract.description.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.contract.description,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.contract.description,
                    label: "Description",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.contract.reset_date,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Reset date"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.contract.reset_date.$model,
                      expression: "$v.contract.reset_date.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "22 November",
                  },
                  domProps: { value: _vm.$v.contract.reset_date.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.contract.reset_date,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.contract.reset_date,
                    label: "Reset date",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.contract.requirement_name,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Requirement type"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single form-control",
                  attrs: {
                    name: "category",
                    options: _vm.requirementOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.contract.requirement_name.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.contract.requirement_name, "$model", $$v)
                    },
                    expression: "$v.contract.requirement_name.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.contract.requirement_name,
                    label: "Requirement type",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.contract.requirement_value,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Requirement value"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.contract.requirement_value.$model,
                      expression: "$v.contract.requirement_value.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "requirement_value",
                    type: "number",
                    placeholder: "0",
                  },
                  domProps: { value: _vm.$v.contract.requirement_value.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.contract.requirement_value,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.contract.requirement_value,
                    label: "Requirement value",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.contract.admin_ids,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Admins"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  ref: "admins",
                  staticClass: "selectize selectize-multiple",
                  attrs: {
                    multiple: "",
                    name: "admins",
                    placeholder: "Admins",
                    "pre-load": true,
                    options: _vm.adminOptions,
                    "fetch-results": _vm.fetchAdminsCallback,
                    "fetch-more-results": _vm.fetchMoreAdminsCallback,
                  },
                  model: {
                    value: _vm.contract.admin_ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.contract, "admin_ids", $$v)
                    },
                    expression: "contract.admin_ids",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveContract,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }